import { useEffect } from 'react'
import { Button, Icon } from '@vp/swan'
import { usePersonalizationManager } from '../PersonalizationManager'

export const MobileModalOpenButton = () => {
  const { setMobileModalOpen, translations, tracking, isInitialized } = usePersonalizationManager()
  const { modalCopy } = translations

  useEffect(() => {
    if (isInitialized) {
      tracking.mobileCtaViewed()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  const handleModalOpen = (): void => {
    setMobileModalOpen(true)
    tracking.flyOutViewed()
  }

  return (
    <Button
      aria-labelledby="personalization-button-label"
      buttonShape="round"
      iconPosition="left"
      paddingX="5"
      skin="primary"
      width="full-width"
      onClick={handleModalOpen}
    >
      {modalCopy.filterHeader}
      <Icon iconType="magic" />
    </Button>
  )
}

MobileModalOpenButton.displayName = 'MobileModalOpenButton'
